import request from '../httpClient';
// tslint:disable
export const getLanguages = (params?: any) =>
  request.get('/languages', params);



// WEBPACK FOOTER //
// ./src/services/api/languageApi.ts